import React from 'react'
import { Row, Col, Card, Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

export default function LicenseClaimSection({ onSelfUse, onShare }) {
	const { t } = useTranslation('account')

	return (
		<div className="mb-4">
			<h2>{t('license_manager.claim.title')}</h2>
			<Row>
				<Col md={6}>
					<Card className="license-claim-card h-100">
						<Card.Body className="d-flex flex-column">
							<h4>{t('license_manager.claim.self_use.title')}</h4>
							<p className="text-muted flex-grow-1">
								{t('license_manager.claim.self_use.description')}
							</p>
							<div>
								<Button variant="link" className="p-0" onClick={onSelfUse}>
									{t('license_manager.claim.self_use.action')}
								</Button>
							</div>
						</Card.Body>
					</Card>
				</Col>
				<Col md={6}>
					<Card className="license-claim-card h-100">
						<Card.Body className="d-flex flex-column">
							<h4>{t('license_manager.claim.share.title')}</h4>
							<p className="text-muted flex-grow-1">
								{t('license_manager.claim.share.description')}
							</p>
							<div>
								<Button variant="link" className="p-0" onClick={onShare}>
									{t('license_manager.claim.share.action')}
								</Button>
							</div>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</div>
	)
}
